<template>
<form action="">
  <div class="modal-card">
    <section class="modal-card-body">
      <iframe v-if="checklist" v-document="checklist"></iframe>
    </section>
  </div>
</form>
</template>

<script>
export default {
  props: {
    checklist: String
  }
}
</script>



// WEBPACK FOOTER //
// src/components/receipts/confirmation/checklist.vue